import React, {useEffect, useState} from "react"
import {useLocation} from "react-router-dom";
import ThemeFormWizard from "../../../components/form/ThemeFormWizard";
import {readFileAsync} from "../../../../../util/Helpers";
import {useCreateThemeMutation} from "../../../../../../redux/apiSlice";
import {useSubheader} from "../../../../../../_metronic/layout";
import cogoToast from "cogo-toast";

const to0xColor = (value) => {
    if (!value) return value;
    const v = `${value}`.trim();
    if (/^0x[0-9a-fA-F]{6}$/.test(v)) return `0x${v.slice(2).toUpperCase()}`;
    if (/^#[0-9a-fA-F]{6}$/.test(v)) return `0x${v.slice(1).toUpperCase()}`;
    if (/^[0-9a-fA-F]{6}$/.test(v)) return `0x${v.toUpperCase()}`;
    return v;
}

const CreateTheme = ({history}) => {
    const subheader = useSubheader();
    useEffect(() => {
        subheader.setTitle("Create Theme")
    }, [subheader])

    const [
        createTheme, // This is the mutation trigger
        {isLoading: isCreating, isSuccess: createdSuccessfully}, // This is the destructured mutation result
    ] = useCreateThemeMutation()

    const [tab, setTab] = useState(1);
    const location = useLocation();

    /* Clear fields on success */
    useEffect(() => {
        if(createdSuccessfully){
            cogoToast.success("Created 'Create Theme' Action Successfully")
            setTab(1)
            history.push("/themes/create");
        }
    }, [createdSuccessfully, history]);

    /* Submit user Data */
    const submitData = async data => {
        const meta = {}
        
        /* Convert files to base64 */
        meta["banner"] = await readFileAsync(data?.banner)
        meta["logo"] = await readFileAsync(data?.logo)
        meta["webSpotlightImage"] = await readFileAsync(data?.webSpotlightImage)
        meta["mobileSpotlightImage"] = await readFileAsync(data?.mobileSpotlightImage)

        meta["bannerBackgroundColor"] = to0xColor(data?.bannerBackgroundColor)
        meta["logoBackgroundColor"] = to0xColor(data?.logoBackgroundColor)
        
        const assets = []
        for (const asset in data?.assets) {
            assets.push({id: asset})
        }

        createTheme({
            theme: {
                name: data.name,
                userGroup: data.userGroup,
                description: data.description,
                status: data.status,
                ...meta,
                assets
            }
        })
    }

    return <ThemeFormWizard
        key={location.key}
        tab={tab}
        setTab={setTab}
        isLoading={isCreating}
        submitData={submitData}
    />
}


export default CreateTheme;
